import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {LocalStorageSettingsService} from "../../../shared/services/local-storage-settings.service";
import {EtlService} from "../../vault-data-migration-etl/etl.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {Radiobutton} from "../../../shared/common/Radiobutton";
import {constants} from "../../../shared/common/contants";
import {DownloadGlobalObjects} from "../../../shared/common/downloadglobalobjects";
import {DownloadMappingFile} from "../../../shared/common/downloadmappingfile";

export interface FormData {
  data: any;
  action: any;

}

@Component({
    selector: 'app-vault-global-objects',
    templateUrl: './vault-global-objects.component.html',
    styleUrls: ['./vault-global-objects.component.scss'],
    standalone: false
})
export class VaultGlobalObjectsComponent implements OnInit {

  columnDefsForObjects;
  rowData;
  rowSelectionForTablesFields;
  rowSelection;
  backgroundColorScreen="";
  buttonColor="";
  allocateButtonsBoolean = false;
  allocateButtons1Boolean = false;
  backgroundColorButton = "";
  vaultObjects:any;
  gridApi;
  defaultColDef;
  components: any;
  selectedVaultObjects:any = {};
  libraryobjectData:any = [];
  objectDetails:any =[];
  objectDataValidation;
  vaultObjectData;
  temp:any=[];
  migrationId
  s3FilePath
  dnsId

  constructor(private dialogref: MatDialogRef<VaultGlobalObjectsComponent>, @Inject(MAT_DIALOG_DATA) public data: FormData,private constants: constants, private localStorageSettings: LocalStorageSettingsService, private service:EtlService, private snackbar: MatSnackBar, private spinner: NgxUiLoaderService) {
    this.components = {
        downloadbuttonRenderer:DownloadGlobalObjects

    }
  }

  ngOnInit() {
    this.migrationId = this.data.data.migrationId;

    this.columnDefsForObjects = [
      {
      headerName: 'Select', filter: false,
      // headerCheckboxSelection: true,
      // headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      // cellRenderer: 'buttonRenderer',
      field:'selection',
      width: 100
    },
      {
        headerName: "Object Name",
        headerTooltip: "Object Name",
        tooltipValueGetter: params => "Object Name : " + params.value,
        field: "objectName",
        filter: "agTextColumnFilter",
        width: 300,
      },
      {
        headerName: "Last Modified Date & Time",
        headerTooltip: "Last Modified Date & Time",
        tooltipValueGetter: params => "Last Modified : " + params.value,
        field: "lastModifiedDateTime",
        filter: false,
        cellRenderer: 'downloadbuttonRenderer',
        cellRendererParams: {
          downloadGlobalObject: this.download.bind(this),
          //delete: this.deleteIcon.bind(this),
        },
        width: 200,

      },


    ];
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelectionForTablesFields='multiple';
    this.rowSelection = this.constants.rowselection;
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    console.log(this.backgroundColorButton);
  }

  /* @added by Ravi G
     @date 9-12-2022
     @desc show vault global objects
  */
  async onGridReadyForObjects(params){
    this.vaultObjects= params;
    this.gridApi= params.api;
    this.objectDetails=[];
    this.gridApi.setGridOption('rowData', [])
    this.spinner.start();
    this.dnsId = this.localStorageSettings.getSettings("dnsName");
    this.service.getGlobalObjectsList(this.dnsId,this.migrationId).subscribe((val) => {
      console.log(val)
      this.objectDetails = val;
      if(this.objectDetails.length ===0){
        this.gridApi.setGridOption('rowData', [])
        this.spinner.stop();
      }else{
        console.log(this.objectDetails)
        this.gridApi.setGridOption('rowData', this.objectDetails);
        this.spinner.stop();
      }
    });
  }

  onRowSelected(event){
    console.log(event)
  //  console.log(event.colDef.cellRenderer)

      console.log(event)
      this.selectedVaultObjects = []
      this.temp = [];
      this.libraryobjectData = [];
      this.libraryobjectData = this.gridApi.getSelectedRows();
      console.log(this.libraryobjectData);
      // For single/multiple object re-extraction
      for (let i = 0; i < this.libraryobjectData.length; i++) {
        console.log(this.libraryobjectData[i].objectName);
        this.selectedVaultObjects.push(this.libraryobjectData[i].objectName);
        // this.selectedVaultObjects = this.libraryobjectData[i].objectName;
        console.log(this.selectedVaultObjects);
    }
    }

  /* @added by Ravi G
     @date 12-12-2022
     @desc create vault global objects
  */
  createglobalObjects(){
    let dnsName = this.localStorageSettings.getSettings("vaultDnsname");
    console.log(dnsName);
    console.log(this.selectedVaultObjects.length);
    if(!this.selectedVaultObjects.length){
      this.snackbar.open("Please select object for create global object", "OK");
    }
    else{
     let obj = {
        "dnsId":this.dnsId,
        "migrationId":this.migrationId,
        "objectNamesList":this.selectedVaultObjects
      }
      console.log(obj)
      this.spinner.start();
      this.service.createGlobalObjects(obj).subscribe(response =>{
        console.log(response);
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
        }
        else{
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.cancel();
        }
      })
    }
  }

  download(e){
    console.log(e.rowData)
    this.s3FilePath = e.rowData.s3Path
    if(this.s3FilePath===undefined || this.s3FilePath=== "" || this.s3FilePath ===null){
      this.snackbar.open(this.constants.fileNotFound, "OK", {duration: 5000});

    }else{
      this.spinner.start();

      var userName = this.localStorageSettings.getSettings("AuthUsername");
      let fileName =  this.s3FilePath.split('/').pop()
      let data = {
        reportType:'',
        s3Path:this.s3FilePath,
        migrationId:this.migrationId,
        userName:userName
      };
      this.spinner.start()
      this.service.downloadEMRLogsFile(data).subscribe(x => {
       
        //     .subscribe(x => {
        // It is necessary to create a new blob object with mime-type explicitly set
        // otherwise only Chrome works like it should
        this.spinner.stop();

        var newBlob = new Blob([x],{type:'application/zip'});

        // IE doesn't allow using a blob object directly as link href
        // instead it is necessary to use msSaveOrOpenBlob
        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //   window.navigator.msSaveOrOpenBlob(newBlob);
        //   return;
        // }

        // For other browsers:
        // Create a link pointing to the ObjectURL containing the blob.
        const data = window.URL.createObjectURL(newBlob);
        console.log(data)
        var link = document.createElement('a');
        link.href = data;
        console.log(e.rowData.fileName)
        link.download =  e.rowData.objectName+"_"+this.migrationId+".zip"
        console.log("ento")
        // this is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
        setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(data);
          link.remove();
        }, 100);
      });

    }

  }

  cancel() {
    this.selectedVaultObjects=[];
    this.dialogref.close();
  }

}
